import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { api, fmtBRL } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { useAuth, can } from "@/lib/auth";

const empty = { nome: "", descricao: "", valor: 0, prazo: "", ativo: true };

export default function Services() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const load = () => api.get("/services").then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try {
      if (editing) await api.put(`/services/${editing.id}`, form);
      else await api.post("/services", form);
      toast.success("Salvo"); setOpen(false); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };
  const remove = async (s) => {
    if (!window.confirm(`Excluir serviço "${s.nome}"?`)) return;
    try { await api.delete(`/services/${s.id}`); toast.success("Serviço excluído"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };
  const canEdit = can(user, "manage_services");
  return (
    <Layout title="Serviços" subtitle="Catálogo de serviços da editora">
      {canEdit && <div className="flex justify-end mb-4">
        <Button data-testid="service-new" onClick={() => { setEditing(null); setForm(empty); setOpen(true); }}><Plus className="w-4 h-4 mr-1"/>Novo</Button>
      </div>}
      <Card className="rounded-sm overflow-hidden">
        <Table>
          <TableHeader className="bg-secondary/60"><TableRow><TableHead>Serviço</TableHead><TableHead>Descrição</TableHead><TableHead>Valor</TableHead><TableHead>Prazo</TableHead><TableHead>Status</TableHead><TableHead className="text-right"></TableHead></TableRow></TableHeader>
          <TableBody>{items.map(s => (
            <TableRow key={s.id}>
              <TableCell className="font-medium">{s.nome}</TableCell>
              <TableCell className="text-muted-foreground text-xs max-w-xs truncate">{s.descricao}</TableCell>
              <TableCell>{fmtBRL(s.valor)}</TableCell><TableCell>{s.prazo}</TableCell>
              <TableCell><Badge variant={s.ativo ? "default" : "secondary"}>{s.ativo ? "Ativo" : "Inativo"}</Badge></TableCell>
              <TableCell className="text-right">
                {canEdit && <>
                  <Button variant="ghost" size="sm" onClick={() => { setEditing(s); setForm(s); setOpen(true); }} data-testid={`service-edit-${s.id}`}><Pencil className="w-4 h-4"/></Button>
                  <Button variant="ghost" size="sm" onClick={() => remove(s)} data-testid={`service-delete-${s.id}`}><Trash2 className="w-4 h-4"/></Button>
                </>}
              </TableCell>
            </TableRow>
          ))}</TableBody>
        </Table>
      </Card>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>{editing ? "Editar" : "Novo"} Serviço</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label className="text-xs font-semibold">Nome</Label><Input data-testid="service-nome" value={form.nome} onChange={(e) => setForm({...form, nome: e.target.value})} className="mt-1"/></div>
            <div><Label className="text-xs font-semibold">Descrição</Label><Textarea value={form.descricao || ""} onChange={(e) => setForm({...form, descricao: e.target.value})} className="mt-1"/></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="text-xs font-semibold">Valor padrão</Label><Input data-testid="service-valor" type="number" value={form.valor} onChange={(e) => setForm({...form, valor: parseFloat(e.target.value) || 0})} className="mt-1"/></div>
              <div><Label className="text-xs font-semibold">Prazo</Label><Input value={form.prazo || ""} onChange={(e) => setForm({...form, prazo: e.target.value})} className="mt-1"/></div>
            </div>
          </div>
          <DialogFooter><Button onClick={save} data-testid="service-save">Salvar</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </Layout>
  );
}
